/**
 *
 * @param {Array} sequence - item to iterate
 * @param {object} objectWithCallback - a contract with an
 * execute method that takes takes an argument which is the
 * current item under iteration and returns an object
 * @returns {object} - result as a single object
 */
const flattenObject = (sequence, objectWithCallback, objectType = []) => {
  if (!objectWithCallback) return sequence;
  return sequence.reduce((acc, cur) => {
    let result = cur;
    if (typeof objectWithCallback.execute === 'function') {
      result = objectWithCallback.execute(cur);
    } else {
      // eslint-disable-next-line no-console
      console.warn(
        'No "execute" method on objectWithCallback, applying default transform whch is to spread - this may fail',
      );
    }
    if (Array.isArray(objectType)) return [...acc, ...result];
    return { ...acc, ...result };
  }, objectType);
};

export default flattenObject;
